import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/booking/page.js");
